module.exports = __webpack_public_path__ + "static/media/telephone.7de2de65.svg";